import React from "react";
import { StaticImage } from "gatsby-plugin-image";
interface Props {}

const BackToTop = (props: Props) => {
  return (
    <button
      sx={{
        border: "none",
        bg: "transparent",
        outline: "none",
        position: "fixed",
        bottom: 1,
        right: 1,
        zIndex: 10,
      }}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <StaticImage
        src="../../images/HeightsBackToTopButton.png"
        alt="Back to top"
        width={80}
      />
    </button>
  );
};

export default BackToTop;
